import React from 'react';
export function WhyChooseUs() {
  return <section className="py-24 bg-white border-y border-warmBorder" data-id="element-1433">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1434">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-1435">
          {/* Image Side */}
          <div className="relative" data-id="element-1436">
            <div className="aspect-square md:aspect-[4/5] overflow-hidden rounded-sm shadow-warm-lg" data-id="element-1437">
              <img src="https://cdn.magicpatterns.com/uploads/sdarZYDeX7g7eKgoo7Xoci/Shane_merem_Convert_this_image_to_34_a1be66d8-cb03-4aef-9a0f-7c418249d2d6.png" alt="Artisan crafting a switch plate" className="w-full h-full object-cover" data-id="element-1438" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-8 -right-8 w-56 h-56 bg-cream border border-warmBorder p-6 hidden md:flex flex-col justify-center items-center text-center shadow-warm z-10" data-id="element-1439">
              <span className="text-5xl font-serif text-gold mb-3" data-id="element-1440">20+</span>
              <span className="text-sm font-bold text-charcoal uppercase tracking-widest leading-relaxed" data-id="element-1441">
                Years of
                <br data-id="element-1442" />
                Excellence
              </span>
            </div>
          </div>

          {/* Content Side */}
          <div data-id="element-1443">
            <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-1444">
              Our Craftsmanship
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6 leading-tight" data-id="element-1445">
              Handmade with Care in West Virginia
            </h2>

            <p className="text-lg text-warmGray mb-6 leading-relaxed" data-id="element-1446">
              For years, homeowners, interior designers, and gift-givers have
              trusted Switchplate Gallery for hand-painted decorative light
              switch plates and outlet covers — all handmade in the USA. We
              don't just sell switchplates — we help you find the perfect
              finishing touch for every room.
            </p>

            <p className="text-lg text-warmGray mb-10 leading-relaxed" data-id="element-1447">
              As a family-run business based in rural Cameron, West Virginia, we
              take immense pride in our craftsmanship. Family members,
              neighbors, and friends work together to create pieces that bring
              joy to homes across the country.
            </p>

            <div className="space-y-8" data-id="element-1448">
              <div className="flex gap-5" data-id="element-1449">
                <div className="flex-shrink-0 mt-1.5" data-id="element-1450">
                  <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-1451">
                    <div className="w-3.5 h-3.5 rounded-full bg-gold" data-id="element-1452"></div>
                  </div>
                </div>
                <div data-id="element-1453">
                  <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-1454">
                    Hand Painted Screws — We're Just Fussy That Way!
                  </h3>
                  <p className="text-warmGray leading-relaxed" data-id="element-1455">
                    Switchplates need screws, and we paint ours to match! Every
                    switchplate we sell ships with carefully matched,
                    hand-painted screws that complement your plate perfectly.
                    It's a small detail that makes a very big difference.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1456">
                <div className="flex-shrink-0 mt-1.5" data-id="element-1457">
                  <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-1458">
                    <div className="w-3.5 h-3.5 rounded-full bg-gold" data-id="element-1459"></div>
                  </div>
                </div>
                <div data-id="element-1460">
                  <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-1461">
                    Hundreds of Themes & Designs
                  </h3>
                  <p className="text-warmGray leading-relaxed" data-id="element-1462">
                    Whatever your decorating theme — beach or tropical,
                    farmhouse or country, classic art or whimsical animals, wine
                    or Parisian, wildlife or horses — we have switchplates to
                    match. They also make wonderful housewarming gifts and
                    clever presents for collectors!
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1463">
                <div className="flex-shrink-0 mt-1.5" data-id="element-1464">
                  <div className="w-12 h-12 rounded-full bg-charcoal/10 flex items-center justify-center" data-id="element-1465">
                    <div className="w-3.5 h-3.5 rounded-full bg-charcoal" data-id="element-1466"></div>
                  </div>
                </div>
                <div data-id="element-1467">
                  <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-1468">
                    Every Size — Including the Hard-to-Find Ones
                  </h3>
                  <p className="text-warmGray leading-relaxed" data-id="element-1469">
                    Singles, doubles, triples, quads, five gang, even six gang
                    by special order. Decora, rocker, GFI, blanks, and
                    combination plates. Can't find your size? Call us at{' '}
                    <a href="tel:8004976946" className="text-gold hover:text-gold-dark font-bold transition-colors" data-id="element-1470">
                      800.497.6946
                    </a>{' '}
                    — we specialize in odd sizes and unusual configurations.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12" data-id="element-1471">
              <a href="/about" className="inline-flex items-center text-terracotta font-bold hover:text-terracotta-dark transition-colors group text-lg uppercase tracking-wider" data-id="element-1472">
                Read Our Full Story
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1473">
                  →
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}